// extracted by mini-css-extract-plugin
export default {"modalOverlay":"ND-z","modalContent":"OD-z","header":"PD-z","close":"QD-z"};